import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconCommentAddFilledSizeL from './IconCommentAddFilled_size_l';
import IconCommentAddFilledSizeM from './IconCommentAddFilled_size_m';
import IconCommentAddFilledSizeS from './IconCommentAddFilled_size_s';
import IconCommentAddFilledSizeXs from './IconCommentAddFilled_size_xs';

const props: CreateIconArguments = {
  l: IconCommentAddFilledSizeL,
  m: IconCommentAddFilledSizeM,
  s: IconCommentAddFilledSizeS,
  xs: IconCommentAddFilledSizeXs,
  name: 'IconCommentAddFilled',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
